import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Interaction } from '@models/auxiliary-company-models';
import { Nullable } from '@models/nullable';

@Component({
  selector: 'bpc-interaction-details',
  templateUrl: './interaction-details.component.html'
})
export class InteractionDetailsComponent {
  @Input() interaction!: Interaction;

  allRecipientEmails: string[] = [];

  get initiator(): string {
    return this.interaction.user.name;
  }

  get internalAttendees(): Nullable<string> {
    return this.interaction.internalAttendees;
  }

  get participants(): Nullable<string> {
    return this.interaction.externalContacts;
  }

  get sanitizedDetails(){
    const div = document.createElement('div');
    div.innerHTML = this.interaction.details;

    const anchors = div.querySelectorAll('a');
    anchors.forEach(anchor => {
      const href = anchor.getAttribute('href');
      if (href && !/^https?:\/\//i.test(href) && !href.startsWith('mailto:') && !href.startsWith('tel:')) {
        anchor.setAttribute('href', `https://${href}`);
      }
    });

    return div.innerHTML;
  }

  ngOnInit() {
    this.allRecipientEmails = this.extractAllRecipientEmails();
  }

  private extractAllRecipientEmails(): string[] {
    try {
      const raw = this.interaction.recipientEmailAddress;
      const parsed = JSON.parse(raw!);
      const extract = (val: any): string[] => {
        if (!val) return [];
        if (Array.isArray(val)) return val;
        return [val];
      };

      const keys = Object.keys(parsed);
      const emailSet = new Set<string>();

      for (const key of keys) {
        if (key != "From"){
          extract(parsed[key]).forEach(email => emailSet.add(email));
        }
      }

      return Array.from(emailSet);
    } catch (error) {
      console.error('Failed to extract emails:', error);
      return [];
    }
  }
}